// release_notes.service.js
import { useCallback, useState, useEffect } from 'react';
import { api } from '@rd-web-markets/shared/dist/services/service';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';

const releaseNotesService = {
  useReleases(params) {
    const [releases, setReleases] = useState([]);
    const [totalPages, setTotalPages] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchReleases = useErrorHandling(useCallback(async () => {
      setLoading(true);
      const response = await releaseNotesService.getAll(params);
      setReleases(response.releases || []);
      setTotalPages(response.pages);
      setLoading(false);
    }, [params]));

    useEffect(() => {
      fetchReleases();
    }, [fetchReleases]);

    return [releases, setReleases, totalPages, loading, fetchReleases];
  },

  getAll: (queryParams = {}) => {
    const query = new URLSearchParams(queryParams).toString();
    return api.get(`/releases?${query}`);
  },
  get: (releaseId) => api.get(`/releases/${releaseId}`),
  create: (data) => api.create('/releases', { release: data }),
  update: (releaseId, data) => api.update(`/releases/${releaseId}`, { release: data }),
  delete: (releaseId) => api.delete(`/releases/${releaseId}`),
  createNote: (releaseId, formData) => api.postFormData(`/releases/${releaseId}/notes`, formData),
  updateNote: (releaseId, noteId, formData) => api.putFormData(`/releases/${releaseId}/notes/${noteId}`, formData),
  deleteNote: (releaseId, noteId) => api.delete(`/releases/${releaseId}/notes/${noteId}`),
};

export default releaseNotesService;